import { Button, Form } from "rsuite";
import { useState, useEffect } from "react";
import {
  UserAddFormType,
  UserAddFormSchema,
  UserAddDefaultValues,
} from "../../models/forms/usersAddForm";
import { UsersAddForm } from "./AddUsersForm.component";
import { ApiUser } from "../../core/apis/user";
import { AppRoutesUI } from "../../config/appRoutes";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../generic/toast.component";
import { useAppDispatch } from "../../core/redux/reduxStore";
import { ActionUI } from "../../core/redux/slices/sliceUI";
import { UtilityDate } from "../generic/dateUtil";

export const AddUsers = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isPaid, setIsPaid] = useState<boolean>(false);
  const [formValue, setFormValue] =
    useState<UserAddFormType>(UserAddDefaultValues);
  const [formError, setFormError] = useState();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    return () => {
      dispatch(
        ActionUI.setUserFormError({
          email: false,
          userName: false,
          firstName: false,
          lastName: false,
          wtaSubType: false,
          tpaSubType: false,
        })
      );
    };
  }, []);

  const expiredDateChange = (
    expiredDate: Date,
    expireCount: number | string
  ) => {
    var newFormData = { ...formValue };
    newFormData.expiryDate = expiredDate;
    newFormData.expireDayCount = expireCount;
    setFormValue(newFormData);
  };
  const onTrialOrPaidChecked = (isTrail: boolean) => {
    var newFormData = { ...formValue };
    if (isTrail) {
      newFormData.expiryDate = UtilityDate.addOneMonthDate(new Date());
    }
    setFormValue(newFormData);
  };
  const handleSave = async (checked: boolean) => {
    const isValidate = () => {
      const isRequiredFieldValidate =
        formValue.email &&
        formValue.userName &&
        formValue.firstName &&
        formValue.lastName &&
        formValue.wtaSubType &&
        formValue.tpaSubType &&
        formValue.userType;
      if (isRequiredFieldValidate) {
        return true;
      } else {
        return false;
      }
    };
    dispatch(
      ActionUI.setUserFormError({
        email: formValue.email ? false : true,
        userName: formValue.userName ? false : true,
        firstName: formValue.firstName ? false : true,
        lastName: formValue.lastName ? false : true,
        wtaSubType: formValue.wtaSubType ? false : true,
        tpaSubType: formValue.tpaSubType ? false : true,
        userType: formValue.userType ? false : true,
      })
    );
    if (isValidate()) {
      const role = "User";
      if (!checked) return;
      setIsLoading(true);
      if (formValue.userType === "trial") {
        setIsPaid(false);
      } else setIsPaid(true);

      const addDays = (date: Date, days: number): Date => {
        date.setDate(date.getDate() + days);
        return date;
      };
      try {
        await ApiUser.createUser(
          formValue.email || "",
          formValue.userName || "",
          formValue.firstName || "",
          formValue.lastName || "",
          formValue.companyName || "",
          formValue.typeOfCompany || "",
          formValue.wtaSubType || "",
          formValue.tpaSubType || "",
          formValue.paidFeatureSubscriptionType || "",
          formValue.phoneNumber || "",
          formValue.userType === "trial" ? false : true || false,
          formValue.registrationDate || new Date(),
          formValue.userType === "paid"
            ? addDays(new Date(), 365) || new Date()
            : formValue.expiryDate || addDays(new Date(), 2),
          formValue.userType === "paid"
            ? "12"
            : formValue.expireDayCount?.toString() || "1",
          role
        ).then((res) =>
          dispatch(
            ActionUI.setAddUserEmailModalView({
              link: res.Data,
              show: true,
            })
          )
        );
        showSuccessToast("User Added Successfully");
      } catch (err: any) {
        showErrorToast(err.response?.data?.Message || err.message);
      }
      navigate(AppRoutesUI.Users.UsersList());
      setFormValue(UserAddDefaultValues);
      setIsLoading(false);
    }
  };

  return (
    <div className="email-card">
      <Form
        formValue={formValue}
        onChange={setFormValue}
        onSubmit={handleSave}
        fluid
      >
        <UsersAddForm
          isPaid={formValue.userType === "trial" ? false : true}
          expiredDateChange={expiredDateChange}
          formValue={formValue}
        />
        <div className="d-flex justify-content-end align-items-center">
          <Button
            size="sm"
            appearance="primary"
            className="m-2 me-3 form-buttons"
            type="submit"
            loading={isLoading}
          >
            Create
          </Button>
        </div>
      </Form>
    </div>
  );
};
